import { useEffect, useState } from "react";
import "../App.css";
import { ImageOverlay } from "react-image-overlay-effect";
function FoodImages() {
  const [show, setShow] = useState(false);

  const [marginTop, setMarginTop] = useState("0rem"); // Initial margin top value

  const style = {
    marginTop: marginTop, // Use the dynamic margin top value
  };

  useEffect(() => {
    if (show === false) {
      setMarginTop("0rem");
      return;
    }
    setMarginTop("12rem");
  }, [show]);

  return (
    <div className="parentReveal">
      <div>
        <h1>Our Food Gallary</h1>
      </div>
      <div className="allImages">
        <div>
          <ImageOverlay
            src="../images/image1.jpg"
            description={<p className="foodName">Guacamole with chips</p>}
          />
        </div>
        <div>
          <ImageOverlay
            src="../images/image2.jpg"
            description={<p className="foodName">Taco de pollo</p>}
          />
        </div>

        {show ? (
          <>
            <div>
              <ImageOverlay
                className="overLay"
                src="../images/image3.jpg"
                description={<p className="foodName">Taco de Chorizo</p>}
              />
            </div>
            <div>
              <ImageOverlay
                src="../images/image4.jpg"
                description={<p className="foodName">Taco de Azada</p>}
              />
            </div>
            <div>
              <ImageOverlay
                className="imageOverlay"
                src="../images/image5.jpg"
                description={<p className="foodName">Taco de Pastor</p>}
              />
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
      <button style={style} onClick={() => setShow(!show)}>
        {show ? "Show less" : "Show more"}
      </button>
    </div>
  );
}

export default FoodImages;
